module.exports = __webpack_public_path__ + "static/img/2015.9370009.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2015.png
// module id = 1yri
// module chunks = 1